import { render, staticRenderFns } from "./StudentWelcome.vue?vue&type=template&id=20759b70&"
import script from "./StudentWelcome.vue?vue&type=script&lang=js&"
export * from "./StudentWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports